import React from "react";
import AuthSignup from "@components/templates/AuthSignup";

export default function AuthSignupScreen(): JSX.Element {
  return <AuthSignup />;
}
